// Pricing type map keyed by tool slug
// Free = only free tier; Freemium = free + paid tiers; Paid = no free tier
export const TOOL_PRICING: Record<string, 'Free' | 'Freemium' | 'Paid'> = {
  'chatgpt': 'Freemium',
  'claude': 'Freemium',
  'midjourney': 'Paid',
  'runway': 'Freemium',
  'elevenlabs': 'Freemium',
  'jasper': 'Paid',
  'copy-ai': 'Freemium',
  'notion-ai': 'Freemium',
  'gamma': 'Freemium',
  'readdy': 'Freemium',
  'descript': 'Freemium',
  'pictory': 'Paid',
  'durable-ai': 'Paid',
  'framer-ai': 'Freemium',
  'zapier-ai': 'Freemium',
  'perplexity-ai': 'Freemium',
  'synthesia': 'Paid',
  'otter-ai': 'Freemium',
  'krisp': 'Freemium',
  'tome': 'Freemium',
  'canva-ai': 'Freemium',
  'dall-e-3': 'Paid',
  'adobe-firefly': 'Freemium',
  'ideogram': 'Freemium',
  'leonardo-ai': 'Freemium',
  'github-copilot': 'Paid',
  'cursor': 'Freemium',
  'tabnine': 'Freemium',
  'replit-ai': 'Freemium',
  'lovable': 'Freemium',
  'bolt-new': 'Freemium',
  'grammarly': 'Freemium',
  'writesonic': 'Paid',
  'rytr': 'Freemium',
  'quillbot': 'Freemium',
  'wordtune': 'Freemium',
  'sora': 'Paid',
  'luma-ai': 'Freemium',
  'kling-ai': 'Freemium',
  'murf-ai': 'Freemium',
  'heygen': 'Freemium',
  'wix-ai': 'Freemium',
  '10web': 'Paid',
  'hostinger-ai': 'Paid',
  'hubspot-ai': 'Paid',
  'surfer-seo': 'Paid',
  'semrush-ai': 'Paid',
  'mailchimp-ai': 'Freemium',
  'hootsuite-ai': 'Paid',
  'jasper-art': 'Paid',
  'adcreative-ai': 'Paid',
  'fireflies-ai': 'Freemium',
  'mem': 'Freemium',
  'superhuman': 'Paid',
  'reclaim-ai': 'Freemium',
  'gemini': 'Freemium',
  'anyword': 'Paid',
  'sudowrite': 'Paid',
  'hypotenuse-ai': 'Paid',
  'longshot-ai': 'Paid',
  'ink-for-all': 'Freemium',
  'frase': 'Paid',
  'peppertype-ai': 'Freemium',
  'scalenut': 'Paid',
  'narrato': 'Freemium',
  'simplified': 'Freemium',
  'contentbot': 'Freemium',
  'lex': 'Freemium',
  'cohesive-ai': 'Freemium',
  'neuroflash': 'Freemium',
  'textcortex': 'Freemium',
  'describely': 'Paid',
  'growthbar': 'Paid',
  'typeface': 'Paid',
  'bing-image-creator': 'Free',
  'playground-ai': 'Freemium',
  'nightcafe': 'Freemium',
  'runway-gen-3': 'Paid',
  'pika-labs': 'Freemium',
  'getimg-ai': 'Freemium',
  'craiyon': 'Free',
  'artbreeder': 'Freemium',
  'pixlr-ai': 'Freemium',
  'fotor-ai': 'Freemium',
  'krea-ai': 'Freemium',
  'invideo-ai': 'Freemium',
  'fliki': 'Freemium',
  'opus-clip': 'Freemium',
  'colossyan': 'Paid',
  'veed-io': 'Freemium',
  'wondershare-filmora-ai': 'Freemium',
  'kapwing': 'Freemium',
  'webflow-ai': 'Freemium',
  'squarespace-ai': 'Paid',
  'bubble': 'Freemium',
  'buffer-ai': 'Freemium',
  'klaviyo-ai': 'Freemium',
  'sprout-social-ai': 'Paid',
  'ahrefs-ai': 'Paid',
  'activecampaign-ai': 'Paid',
  'manychat-ai': 'Freemium',
  'motion-ai': 'Paid',
  'taskade-ai': 'Freemium',
  'codeium': 'Freemium',
  'amazon-codewhisperer': 'Freemium',
  'windsurf': 'Freemium',
  'pieces-for-developers': 'Free',
  'devin-ai': 'Paid',
  'looka': 'Paid',
  'stability-ai': 'Freemium',
  // New tools
  'uizard': 'Freemium',
  'khroma': 'Free',
  'magician': 'Freemium',
  'predis-ai': 'Freemium',
  'instantly-ai': 'Paid',
  // AI Automation Tools
  'make': 'Freemium',
  'n8n': 'Freemium',
  'manus-ai': 'Free',
  'agentgpt': 'Freemium',
  'relevance-ai': 'Freemium',
  'activepieces': 'Freemium',
  'bardeen': 'Freemium',
  'lindy-ai': 'Freemium',
  'pipedream': 'Freemium',
  'relay-app': 'Freemium',
  'voiceflow': 'Freemium',
  'stack-ai': 'Freemium',
  'botpress': 'Freemium',
  'flowise': 'Free',
  'crewai': 'Free',
  // New additions
  'grok': 'Freemium',
  'speechify': 'Freemium',
  'resemble-ai': 'Paid',
  'podcastle': 'Freemium',
  'cleanvoice': 'Paid',
  'picsart-ai': 'Freemium',
  'loom-ai': 'Freemium',
  // 10 new tools — March 2026
  'microsoft-copilot': 'Freemium',
  'suno-ai': 'Freemium',
  'udio': 'Freemium',
  'photoroom': 'Freemium',
  'character-ai': 'Freemium',
  'beautiful-ai': 'Freemium',
  'poe': 'Freemium',
  'captions-ai': 'Freemium',
  'cohere': 'Freemium',
  'dify': 'Freemium',
};

export type PricingType = 'Free' | 'Freemium' | 'Paid';
